import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import {
  OrderDocumentDownloadRequestType,
  OrderDocumentDownloadResponseType,
} from "@sellar-io/api-v2/types";

export const useOrderDocumentDownload = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OrderDocumentDownloadRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `order-documents/download`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<OrderDocumentDownloadResponseType>(response).data,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.OrderDocument],
      });
    },
  });
};
